<template>
  <main class="dashboard reviews">
    <ReviewHead></ReviewHead>
    <div class="filters">
      <div class="graph-header">
        <div class="legend">
          <div class="dropdown">
            <ul class="selected" v-if="resources.filter(x=>x.check).length">
              <li v-for="resource in resources.filter(x=>x.check)">
                <div class="name">
                  <div class="resource-checkbox">
                    <input type="checkbox" name="" :id="`review-list-select-${resource.id}`"
                           v-model="resource.check">
                    <label :for="`review-list-select-${resource.id}`">
                    <span :style="{backgroundColor: resource.color, borderColor: resource.color}" class="check"><i
                        class="bi bi-check"></i></span>
                      {{ resource.name || resource.domain }}</label>
                  </div>
                </div>
              </li>
            </ul>
            <span v-else>Источники</span>
            <button class="" type="button" data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="outside">
              <i class="bi bi-chevron-down"></i>
            </button>
            <ul class="dropdown-menu">
              <li v-for="resource in resources">
                <div class="name">
                  <div class="resource-checkbox">
                    <input type="checkbox" name="" :id="`review-list-choice-${resource.id}`"
                           v-model="resource.check">
                    <label :for="`review-list-choice-${resource.id}`">
                    <span :style="{backgroundColor: resource.color, borderColor: resource.color}" class="check"><i
                        class="bi bi-check"></i></span>
                      {{ resource.name || resource.domain }}</label>
                  </div>
                </div>
              </li>
            </ul>

          </div>
        </div>

        <div class="ms-2">
          <input type="text" v-model="search" placeholder="Поиск по ссылке..." class="form-control">
        </div>

        <button type="button" class="btn btn-dark ms-2 btn-sm" @click="page=1;getData()">
          <i class="bi bi-search"></i> <span>Показать</span></button>

      </div>
      <div class="per-page">
        <select v-model="size" key="per_page" class="form-control">
          <option v-for="s in sizes" :value="s">{{ s }}</option>
        </select>
      </div>
    </div>

    <div class="responses">
      <div class="response card" v-for="review in reviews">
        <div class="header">
          <div class="info">
            <div class="resource" v-if="review.resource">
                  <span class="img" v-if="review.resource?.ico"
                        :style="{backgroundImage: `url(${review.resource.ico})`}"></span>
              <span class="img no-image" v-else :style="{backgroundColor: review.resource?.color}"></span>

              <a :href="review.review_site_url" target="_blank"
                 class="name">{{ review.resource?.name || review.resource?.domain }}</a>
            </div>
            <div class="date-response" v-if="review.date_response">
              <span v-if="review.city">{{ review.city }}, </span>
              {{ $moment(review.date_response).format("DD.MM.YY HH:mm") }}
              <span class="version" v-if="(review.versions-1)>0"> <b> версий</b>: {{ review.versions - 1 }}</span>
            </div>
          </div>
          <div class="rating">
            <div class="badge" v-if="review.tone" :style="{background: $COLORS[review.tone]}">
              {{ review.get_tone_display }}
            </div>
            <div class="star-rating" :data-rating="review.rating">
              <div class="stars-container">
                <svg class="stars-background" viewBox="0 0 100 20">
                  <polygon points="10,2 4,19 19,8 1,8 16,19" fill="lightgray"/>
                  <polygon points="30,2 24,19 39,8 21,8 36,19" fill="lightgray"/>
                  <polygon points="50,2 44,19 59,8 41,8 56,19" fill="lightgray"/>
                  <polygon points="70,2 64,19 79,8 61,8 76,19" fill="lightgray"/>
                  <polygon points="90,2 84,19 99,8 81,8 96,19" fill="lightgray"/>
                </svg>
                <div class="stars-foreground" :style="{'--rating': review.rating}">
                  <svg viewBox="0 0 100 20" preserveAspectRatio="none">
                    <polygon points="10,2 4,19 19,8 1,8 16,19" fill="#D59A00"/>
                    <polygon points="30,2 24,19 39,8 21,8 36,19" fill="#D59A00"/>
                    <polygon points="50,2 44,19 59,8 41,8 56,19" fill="#D59A00"/>
                    <polygon points="70,2 64,19 79,8 61,8 76,19" fill="#D59A00"/>
                    <polygon points="90,2 84,19 99,8 81,8 96,19" fill="#D59A00"/>
                  </svg>
                </div>
              </div>
              <span class="rating-value">{{ review.rating }}</span>
            </div>
          </div>
        </div>
        <div class="text d-flex" style="flex-direction: column; gap: 5px">
          <div>
            <p><b>Текст отзыва:</b> {{ review.content?.text }}</p>
          </div>

        </div>
        <div class="bottom">
          <div class="tags">
            <div class="badge bg-secondary" v-for="tag in review.tags">
              {{ tag.name }}
            </div>
            <a v-if="review.review_id && review.review_id.indexOf('http')+1" :href="review.review_id" target="_blank"><i
                class="bi bi-box-arrow-up-right"></i></a>

          </div>
          <div class="answer-count" @click="review.show_answer=!review.show_answer">Ответов:
            {{ review.content?.responses?.length || 0 }}
          </div>
        </div>

        <div class="answers" v-show="review.show_answer">
          <div class="answer" v-for="answer in review.content?.responses">
            <div class="date-response" v-if="answer.date">
              {{ $moment(answer.date).format("DD.MM.YY HH:mm") }}
            </div>
            <div class="text">
              {{ answer.text }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <PagerList class="mt-3" v-bind:pager="response_pager" v-bind:updatePage="updateResponsePage"
               v-bind:page="page"></PagerList>
  </main>
</template>

<script>

import {ReviewApi} from "@/api/reviews";
import ReviewHead from "@/views/dictionary/review/ReviewHead.vue";
import PagerList from "@/components/includes/PagerList.vue";
import responses from "@/views/dictionary/Responses.vue";

export default {
  name: 'ReviewList',
  components: {PagerList, ReviewHead},
  data() {
    return {
      page: 1,
      size: 20,
      sizes: [10, 20, 50, 100],
      reviews: [],
      resources: [],
      response_all_count: 0,
      search: "",
    }
  },
  watch: {
    page() {
      this.getData()
    },
    size() {
      this.page = 1
      this.getData()
    },
  },
  computed: {
    response_pager() {
      return this.response_pager = this.$func.getPagerArray(this.response_all_count, this.size, this.page)
    }
  },
  mounted() {
    this.getData();
    ReviewApi.resource_list().then(response => this.resources = response)
  },
  methods: {
    createSearchParams: (params) => {
      const searchParams = new URLSearchParams();
      Object.entries(params).forEach(([key, values]) => {
        if (Array.isArray(values)) {
          values.forEach((value) => {
            searchParams.append(key, value);
          });
        } else {
          searchParams.append(key, values);
        }
      });
      return searchParams;
    },
    getData() {
      const $this = this;
      let domains = this.resources.filter(x => x.check).map(x => x.id)
      let filters = {}
      if (domains.length) filters.domains = domains
      if (this.search.length) filters.search = this.search
      filters = this.createSearchParams(Object.fromEntries(Object.entries(filters).filter(([_, v]) => Array.isArray(v) ? v.length : !!v)))
      ReviewApi.reviews_uniq(this.page, this.size, filters).then(response => {
        $this.reviews = response.results
        $this.response_all_count = response.count;
      })

    },
    updateResponsePage(page) {
      this.page = page
    }
  }
}
</script>

<style scoped lang="scss">
.head {
  justify-content: space-between;
}

.status {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 10px;

  .process {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    display: block;
    margin: 0 auto;
    position: relative;
    background: #F0F0F0FF;
    box-shadow: -24px 0 #F0F0F0FF, 24px 0 #F0F0F0FF;
    box-sizing: border-box;
    animation: shadowPulse 2s linear infinite;
  }
}


@keyframes shadowPulse {
  33% {
    background: #F0F0F0FF;
    box-shadow: -24px 0 #87CEFAFF, 24px 0 #F0F0F0FF;
  }
  66% {
    background: #87CEFAFF;
    box-shadow: -24px 0 #F0F0F0FF, 24px 0 #F0F0F0FF;
  }
  100% {
    background: #FFF;
    box-shadow: -24px 0 #F0F0F0FF, 24px 0 #87CEFAFF;
  }
}

.responses {
  display: flex;
  flex-direction: column;
  gap: 20px;

  .response {
    border: 1px solid #ccc;
    border-radius: 5px;
    padding: 10px;
    display: flex;
    flex-direction: column;

    .header {
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid #ccc;
      padding: 3px 0;

      .info {
        display: flex;
        gap: 10px;
      }

      .rating {
        display: flex;
        gap: 10px;
        align-items: center;

        .badge {
          font-size: 10px;
        }

        .star-rating {
          display: inline-flex;
          align-items: center;
          font-size: 16px;

          .stars-container {
            position: relative;
            width: 100px;
            height: 20px;

            .stars-background {
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
            }

            .stars-foreground {
              position: absolute;
              top: 0;
              left: 0;
              width: calc(var(--rating) / 5 * 100%);
              height: 100%;
              overflow: hidden;

              svg {
                width: 100px;
                height: 100%;
              }
            }
          }

          .rating-value {
            font-size: 12px;
            margin-left: 5px;
          }
        }


      }


    }


    .resource {
      display: flex;
      gap: 4px;
      align-items: center;
      margin-bottom: 10px;

      .img {
        display: inline-block;
        width: 16px;
        height: 16px;
        background-position: center;
        background-size: contain;

        &.no-image {
          background: #ccc;
          border-radius: 16px;
        }
      }

      .name {
        font-size: 12px;
        font-weight: 400;
        line-height: 20px;
      }
    }

    .date-response {
      font-size: 10px;
    }

    .text {
      margin-top: 5px;
      font-size: 12px;
    }

    .bottom {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .tags {
        display: flex;
        gap: 10px;
      }

      .answer-count {
        font-size: 10px;
        text-align: right;
        margin-left: auto;
        border-bottom: 1px dotted;
        cursor: pointer;
        line-height: 1;
      }
    }


    .answers {
      display: flex;
      flex-direction: column;
      gap: 15px;
      margin-left: 40px;
      margin-top: 15px;

      .answer {
        border-left: 1px solid #ccc;
        padding-left: 15px;
      }
    }

  }
}

.filters {
  border-bottom: 1px solid rgb(196, 199, 207);
  margin: -10px -20px;
  padding: 0 20px 13px;
  margin-bottom: 24px;
  display: flex;

  .per-page {
    margin-left: auto;
  }


  .graph-header {
    align-items: center;
    display: flex;
    justify-content: start;
    gap: 15px;

    input {
      height: 33px;
      border: 1px solid #ccc;
      font-size: 12px;
      border-radius: 5px;
      background: transparent;

      &::placeholder {
        color: #666;
        font-size: 12px;
        line-height: 12px;
      }
    }

    .legend {
      max-width: 50%;


      .dropdown {
        margin-right: 0;

        span {
          color: #666;
          font-size: 12px;
        }
      }
    }
  }
}

.card-header {
  gap: 50px;
}


@media (width < 768px) {
  .card-header {
    flex-direction: column;
    gap: 5px;

    a.btn {
      order: -1;
    }
  }
}

</style>


